import { Icon, IconProps } from "@chakra-ui/react"

const RightArrow = (props: IconProps) => (
  <Icon
    width='13px'
    height='20px'
    viewBox='0 0 13 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 -4.37114e-07L12.5 10L2.5 20L1.88725e-07 17.5L7.5 10L8.44396e-07 2.5L2.5 -4.37114e-07Z'
      fill='white'
    />
  </Icon>
)

export default RightArrow
